import type { ReactNode } from 'react';
import { Option } from './Option';
import type { OptionState, QuestionCss } from './types';

const DEFAULT_CSS = {
  container: '',
  title: 'text-sm font-semibold text-slate-800',
  list: 'mt-3 space-y-2'
};

interface QuestionProps {
  question: string;
  options: string[];
  optionState: (index: number) => OptionState;
  onSelect?: (index: number) => void;
  isDisabled?: (index: number) => boolean;
  showLetters?: boolean;
  optionTrailing?: (index: number) => ReactNode;
  title?: ReactNode;
  feedback?: ReactNode;
  css?: QuestionCss;
}

export function Question({
  question,
  options,
  optionState,
  onSelect,
  isDisabled,
  showLetters = true,
  optionTrailing,
  title,
  feedback,
  css
}: QuestionProps) {
  return (
    <div className={css?.container ?? DEFAULT_CSS.container}>
      {title ?? <p className={css?.title ?? DEFAULT_CSS.title}>{question}</p>}

      <ul className={css?.list ?? DEFAULT_CSS.list}>
        {options.map((option, index) => (
          <li key={index}>
            <Option
              index={index}
              label={option}
              state={optionState(index)}
              disabled={isDisabled?.(index)}
              showLetter={showLetters}
              onSelect={onSelect}
              css={css?.option}
              trailing={optionTrailing?.(index)}
            />
          </li>
        ))}
      </ul>

      {feedback}
    </div>
  );
}
